<template>
	<inertia-head title="Sidebar Control" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Sidebar Control</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Manage Dashboard Sidebar
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>MENU</th>
								<th>ICON</th>
								<th>URL</th>
								<th>RIBBON</th>
								<th>SUBMENU</th>
								<th>STATUS</th>
								<th>RANK VISIBILITY</th>
								<th>:::</th>
							</tr>
						</thead>
						<tbody class="fs-xs">
							<tr v-for="row in rows.data" :key="row.counter">
								<td>{{ row.sidebar_menu }}</td>
								<td class="text-start">{{ row.icon }}</td>
								<td class="text-start text-info fw-semibold">
									<i>{{ row.url ?? '-' }}</i>
								</td>
								<td>{{ row.ribbon ?? '-' }}</td>
								<td>
									<div v-if="row.has_submenu">
										<inertia-link
											:href="route('admin.post.submenu-list', row.id)"
											method="post"
											as="button"
											class="btn btn-sm btn-outline-secondary"
											preserve-state
											preserve-scroll
										>
											<i class="fa fa-list"></i>
										</inertia-link>
									</div>
									<div v-else>-</div>
								</td>
								<td>
									<div class="form-check form-switch form-check-inline">
										<input
											class="form-check-input"
											type="checkbox"
											:checked="row.status"
											:value="row.status"
											:id="row.id"
											@change="handleStatus"
										/>
										<label class="form-check-label">
											<small>{{ row.status ? 'ON' : 'OFF' }}</small>
										</label>
									</div>
								</td>
								<td>
									<small>{{ row.rank_visibility }}</small>
								</td>
								<td class="space-x-1">
									<div class="btn-group">
										<inertia-link
											:href="
												route('admin.post.show-sidebar-details', {
													id: row.id,
													table: 'tbl_sidebar_menu',
												})
											"
											method="post"
											as="button"
											class="btn btn-sm btn-alt-info js-bs-tooltip-enable me-1"
											data-bs-toggle="tooltip"
											data-bs-original-title="Edit"
											preserve-state
											preserve-scroll
										>
											<i class="fa fa-pencil-alt"></i>
										</inertia-link>
										<button
											type="button"
											class="btn btn-sm btn-alt-danger js-bs-tooltip-enable"
											data-bs-toggle="tooltip"
											data-bs-original-title="Delete"
										>
											<i class="fa fa-trash"></i>
										</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<sidebar-menu-details-modal
		ref="sidebarMenuDetailsModal"
		:selectedMenu="selectedMenu"
	/>
	<submenu-list-modal
		ref="submenuListModal"
		:submenus="submenus"
		:subMenuParent="subMenuParent"
	/>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import AuthLayout from '../../../Layouts/AuthLayout'
import SidebarMenuDetailsModal from '../../../Components/Admin/SiteManagement/SidebarMenuDetailsModal'
import SubmenuListModal from '../../../Components/Admin/SiteManagement/SubmenuListModal'

export default {
	layout: AuthLayout,
	props: {
		rows: Object,
		flash: Object,
		errors: Object,
	},
	components: {
		SidebarMenuDetailsModal,
		SubmenuListModal,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const selectedMenu = ref(null)

		const submenus = ref(null)

		const subMenuParent = ref(null)

		const sidebarMenuDetailsModal = ref(null)

		const submenuListModal = ref(null)

		const handleStatus = (e) => {
			Inertia.post(
				route('admin.post.update-menu-status'),
				{
					id: e.target.id,
					status: e.target.value,
					table: 'tbl_sidebar_menu',
				},
				{
					preserveState: true,
					preserveScroll: true,
					only: ['rows', 'flash'],
				}
			)
		}

		watch(
			() => props.flash,
			(flash) => {
				if (flash) {
					if (flash.modal_data) {
						if (flash.modal_data.submenus) {
							submenus.value = flash.modal_data.submenus
							subMenuParent.value = flash.modal_data.parent
							if (submenus.value) submenuListModal.value.toggleModal()
						}

						if (flash.modal_data.sidebar_menu) {
							selectedMenu.value = flash.modal_data.sidebar_menu
							if (selectedMenu.value)
								sidebarMenuDetailsModal.value.toggleModal()
						}
					}

					if (flash.update) {
						submenus.value = flash.update.submenus
					}
				}
			}
		)

		return {
			submenus,
			selectedMenu,
			handleStatus,
			submenuListModal,
			sidebarMenuDetailsModal,
			subMenuParent,
		}
	},
}
</script>
